import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataCategoriesService } from 'app/app-services/data-categories-service';
import { NavigationService } from 'app/app-services/navigation.service';
import { SpecificationService } from 'app/app-services/specification-service';
import { SpecificationStatusService } from 'app/app-services/specification-status.service';
import { FlashCategoryItem } from 'app/data-categories/flash/flash-category-item';
import { AuthService } from 'app/modules/authentication/services/auth.service';
import { Category } from 'app/specification-structure/category-items/category.enum';
import { CategoryComponentBaseComponent } from '../../modules/shared/model/category-component-base';
import { MessageService } from '../../modules/shared/services/message-service.service';

@Component({
  selector: 'app-flash',
  templateUrl: './flash.component.html',
  styleUrls: ['./flash.component.css']
})
export class FlashComponent extends CategoryComponentBaseComponent<FlashCategoryItem> implements OnInit {

  flashItem: FlashCategoryItem;

  constructor(activatedRoute: ActivatedRoute,
    private specificationStatusService: SpecificationStatusService,
    specificationService: SpecificationService,
    categoryService: DataCategoriesService,
    navigationService: NavigationService,
    messageService: MessageService, private authService:AuthService) {
    super(specificationService, activatedRoute, categoryService, messageService, Category.Flash, navigationService);
  }

  ngOnInit() {
    this.componentSubscriptions.push(this.itemChanged.subscribe(item => {
      this.flashItem = item;
    }));
  }

  get isEditingAllowed(): boolean {
    return this.specificationStatusService.isInWork(this.specificationService.currentSpecificationVersion);
  }

  get editingNotAllowedReason(): string {
    return this.specificationStatusService.notAllowedInReleaseText;
  }

  editingNameDone(name: string) {
    if (name.trim().length > 0) {
      this.flashItem.setName(name.trim());
    } else {
      this.messageService.dispatchErrorMessage('Flash name can not be empty!');
    }
  }

  canEditCategoryItems():boolean{
    return this.authService.canEditCategoryItems();
  }
}
